/**
 * Shared surface colours.
 */
import { hex } from './math.js';

export const palette = {
  armor: hex('#56645b'),
  edge: hex('#849082'),
  dark: hex('#242f30'),
  joint: hex('#252d2b'),
  accent: hex('#d19250'),
  light: hex('#d8d3af'),
  visor: hex('#ffc976'),
  hostile: hex('#845a49'),
  hostileLight: hex('#a27758'),
  ground: hex('#9d7455'),
  rock: hex('#705c4c'),
};
